import React from 'react'
import { LayoutBand } from '@fs/zion-ui'
import PageBannerText from './PageBannerText'
import ContentContainer from './ContentContainer'
import useIsMobile from '../hooks/useIsMobile'

export default function PageBanner({ heading, subheading, reducedBottomPadding }) {
  const isMobile = useIsMobile()
  const bottomPadding = reducedBottomPadding ? 48 : 100
  return (
    <LayoutBand>
      <ContentContainer>
        <div style={{ height: isMobile ? 48 : 100 }} />
        <PageBannerText heading={heading} subheading={subheading} />
        <div style={{ height: isMobile ? 48 : bottomPadding }} />
      </ContentContainer>
    </LayoutBand>
  )
}
